import React, { Component, Fragment,useState  } from 'react'
import { connect } from 'react-redux'
import moment from 'moment';
import FontAwesome from 'react-fontawesome'

import { toast } from 'react-toastify'

import Box from '../components/Layout/Box'
import BoxButton from '../components/Layout/BoxButton'
import ButtonStrip from '../components/Layout/ButtonStrip'
import BoxSection from '../components/Layout/BoxSection'

import ModalAddFile from '../components/Shared/ModalAddFile'
import ModalSelectorFromList from '../components/Shared/ModalSelectorFromList'
import ModalSelectorAirport from '../components/Shared/ModalSelectorAirport'
import SelectorInput from '../components/Shared/SelectorInput'
import AttachedFilesBox from '../components/Shared/AttachedFilesBox'


import {
    displayModalAddFile,
    selectFile,
    updateInputs as updateInputsModalAddFile,
    showModalSelector,
    selectFromSelector,
    showModalSelectorUrlAirports,
} from '../actions/common'


import {
    updateInputs,
    addTrayecto,
    removeTrayectos,
    createTiqueteAereo,
    addFile,
    addPasajero,
    addOrigen,
    addDestino,
    addCencoSolicitud,
    removeCenco,
    validateCaducidadPasaporte,
    enviarComentario,
    editarComentario,
    eliminarComentario,
    addFileAdjunto,
    removeSolicitudTiqutesAereos
} from '../actions/creaciontiqueteaereo'




class CreacionTiquetesAereo extends Component {




    handleOpenSelector = (path) => {
        let columns = [
            { id: 1, caption: 'Identificacion', value: 'username', width: '30%' },
            { id: 2, caption: 'Nombre', value: 'fullname', width: '70%' },
        ]
        const payload = {}
        const fn = (a) => {
            payload.path = path
            payload.value = a
            this.props.selectFromSelector('MODIFICAR_INPUTS_SOLICITUD_TIQUETESAEREO', payload)
        }
        this.props.showModalSelector('Listado de usuarios', columns, '/usuarios/cencos', fn)
    }


    handleOpenSelectorAddCenco = (list, index) => {
        let columns = [
            { id: 1, caption: 'Codigo', value: 'codigo', width: '30%' },
            { id: 2, caption: 'Descripcion', value: 'descripcion', width: '70%' }
		]

        const payload = {}
        const fn = (a) => {
            const index = this.props.creaciontiqueteaereo.get('cencos').findIndex(c => c.getIn(['cenco', 'id']) == a.id)
            if (index >= 0) {
                toast.warn(`El cenco ${a.codigo} ya se encuentra en el listado`, { bodyClassName: 'toastify-content toastify-warning' })
            } else {
                payload.path = list
                payload.value = a
                this.props.selectFromSelector('MODIFICAR_INPUTS_SOLICITUD_TIQUETESAEREO', payload)
            }
        }
        const customFilter = { column: 'T0.responsable_id', operator: '===', value: this.props.creaciontiqueteaereo.getIn(['cencos', index, 'responsable', 'id']), comparison: 'string' }
        this.props.showModalSelector('Listado de CENCOS', columns, '/cencos', fn, customFilter)
	}




    handleOpenSelectorAddPasajero = (path) => {
        let columns = [
            { id: 1, caption: 'Identificacion', value: 'username', width: '30%' },
            { id: 2, caption: 'Nombre', value: 'fullname', width: '70%' }
        ]
        const payload = {}
        const fn = (a) => {
            payload.path = path
            payload.value = a
            this.props.selectFromSelector(() => this.props.addPasajero(payload))
        }
        this.props.showModalSelector('Listado de usuarios', columns, '/usuarios/ldap', fn)
    }



    handleOpenSelectorUbicacionOrigen = (path) => {
        let columns = [
            { id: 1, caption: 'Código', value: 'code', width: '30%' },
            { id: 2, caption: 'Nombre', value: 'name', width: '35%' },
            { id: 3, caption: 'País', value: 'country_name', width: '35%' }
        ]
        const payload = {}
        const fn = (a, query) => {
            payload.path = path
            payload.value = a
            this.props.selectFromSelector(() => this.props.addOrigen(payload, query))
        }
        this.props.showModalSelectorUrlAirports('Listado de aeropuertos', columns, '/aeropuertos', fn)
    }



    handleOpenSelectorUbicacionDestino = (path) => {
        let columns = [
            { id: 1, caption: 'Código', value: 'code', width: '30%' },
            { id: 2, caption: 'Nombre', value: 'name', width: '35%' },
            { id: 3, caption: 'País', value: 'country_name', width: '35%' }
        ]
        const payload = {}
        const fn = (a,query) => {
            payload.path = path
            payload.value = a
            this.props.selectFromSelector(() => this.props.addDestino(payload, query))
        }
        this.props.showModalSelectorUrlAirports('Listado de aeropuertos', columns, '/aeropuertos', fn)
    }


    handleAeropuerto = (index, tipo, value) => {

        if (tipo === 'origen') {
            this.props.updateInputs(`trayectos.${index}.origen`, value)
            this.props.updateInputs(`trayectos.${index}.aeropuerto_origen`, value)
        }

        if (tipo === 'destino') {
            this.props.updateInputs(`trayectos.${index}.destino`, value)
            this.props.updateInputs(`trayectos.${index}.aeropuerto_destino`, value)
        }
    }


    onResetAeropuerto = (tipo, index) => {



        if (tipo == 'origen') {
            this.props.updateInputs(`trayectos.${index}.origen`, null)
            this.props.updateInputs(`trayectos.${index}.aeropuerto_origen`, null)
        }

        if (tipo == 'destino') {
            this.props.updateInputs(`trayectos.${index}.destino`, null)
            this.props.updateInputs(`trayectos.${index}.aeropuerto_destino`, null)
        }

    }

    getTotalDias = (index) => {
        const { creaciontiqueteaereo } = this.props
        const fecha_salida = creaciontiqueteaereo.getIn(['pasajeros', index, 'asistencia', 'fecha_salida'])
        const fecha_regreso = creaciontiqueteaereo.getIn(['pasajeros', index, 'asistencia', 'fecha_regreso'])
        if (!fecha_salida || !fecha_regreso) return 0
        return Math.abs(moment(fecha_regreso).diff(moment(fecha_salida), 'days'))
    }

	render() {

        const { creaciontiqueteaereo, enums} = this.props
        const tipo_viaje = creaciontiqueteaereo.get('tipo_viaje')
        const asistencia_vajero = creaciontiqueteaereo.get('asistencia_viajero')
        const tipo_trayecto = creaciontiqueteaereo.get('tipo_trayecto')
        const tipos_identificacion = enums.tipos_identificacion
        const flagAdjunto = creaciontiqueteaereo.get('flagAdjunto')
        // let openModal = "";


        const boxActions = [
            <BoxButton key="ba[0][1]" name="floppy-o" onClick={ () => this.props.createTiqueteAereo() } title="Guardar"  />,
        ]

        const accionesTrayectos = [
            <BoxButton key="ba[1][0]" size={14} contrast name="plus-circle" title="Adicionar trayecto" onClick={ () => this.props.addTrayecto() } disabled={(creaciontiqueteaereo.get('tipo_trayecto') != 3)}  />,
            <BoxButton key="ba[1][1]" size={14} contrast name="trash" title="Eliminar trayecto" onClick={ () => this.props.removeTrayectos() } danger disabled={(creaciontiqueteaereo.get('tipo_trayecto') != 3)}/>,
        ]


        const actionsDistribucionCencos = [
            <BoxButton key="ba[2][0]" size={14} contrast name="plus-circle" title="Nuevo" onClick={ () => this.props.addCencoSolicitud() } />,
            <BoxButton key="ba[2][1]" size={14} contrast name="trash" title="Eliminar" onClick={ () => this.props.removeCenco() } danger />,
        ]

		return (
            <div className="row" style={{ height: '100%', overflowX: 'hidden' }}>
                <div className="col-md-12" style={{ height: '100%' }}>

                    <div className="separator"></div>

                    <Box title="Solicitud de tiquete aéreo > Creación">

                        <ButtonStrip actions={ boxActions } />

                        <div className="box-content">

                            <Fragment>

                                <BoxSection title="Información básica">

                                <div className="row">

                                        <div className="col-md-5">
                                            <div className="form-group">
                                                <label className="control-label">Solicitante</label>
                                                <input type="text" value={this.props.user.get('fullname') || ''} className="form-control input-sm" disabled />
                                            </div>
                                        </div>

                                        <div className="col-md-3">
                                            <div className="form-group">
                                                <label className="control-label">Correo</label>
                                                <input type="text" value={this.props.user.get('email') || ''} className="form-control input-sm" disabled />
                                            </div>
                                        </div>


                                        <div className="col-md-1">
                                            <div className="form-group">
                                                <label className="control-label">Extensión</label>
                                                <input type="text" value={this.props.user.get('extension') || ''} className="form-control input-sm" disabled />
                                            </div>
                                        </div>


                                        <div className="col-md-3">
                                            <div className="form-group">
                                                <label className="control-label">Área</label>
                                                <input type="text" value={this.props.user.getIn(['area', 'nombre']) || ''} className="form-control input-sm" disabled />
                                            </div>
                                        </div>

                                    </div>


                                    <div className="row">
                                        <div className="col-md-5">
                                            <div className="form-group">
                                                <label className="control-label">Responsable de compras</label>
                                                <input className="form-control input-sm" type="text" value={enums.solicitudes.tipos[creaciontiqueteaereo.get('tipo')].responsable.fullname || ''} disabled />
                                            </div>
                                        </div>

                                        <div className="col-md-3">
                                            <div className="form-group">
                                                <label className="control-label">Correo</label>
                                                <input className="form-control input-sm" value={enums.solicitudes.tipos[creaciontiqueteaereo.get('tipo')].responsable.email || ''} disabled />
                                            </div>
                                        </div>

                                        <div className="col-md-1">
                                            <div className="form-group">
                                                <label className="control-label">Extensión</label>
                                                <input className="form-control input-sm" type="text" value={enums.solicitudes.tipos[creaciontiqueteaereo.get('tipo')].responsable.extension || ''} disabled />
                                            </div>
                                        </div>

                                        <div className="col-md-2">
                                            <div className="form-group">
                                                <label className="control-label">Fecha de solicitud</label>
                                                <input className="form-control input-sm" value={moment().format('YYYY/MM/DD')} disabled />
                                            </div>
                                        </div>

                                    </div>

                                </BoxSection>


                                <div className="separator"></div>


                                <BoxSection title="Información del viaje">

                                    <div className="row">

                                        <div className="col-md-4">
                                            <div className="form-group">
                                                <label className="control-label">Motivo del viaje</label>
                                                <input className="form-control input-sm" type="text" value={ creaciontiqueteaereo.get('motivo_viaje') || ''  } onChange={ e => this.props.updateInputs('motivo_viaje', e.target.value) } />
                                            </div>
                                        </div>

                                        <div className="col-md-2">
                                            <div className="form-group">
                                                <label className="control-label">Tipo de viaje</label>
                                                <select className="form-control input-sm" value={ creaciontiqueteaereo.get('tipo_viaje') || ''  } onChange={ e => this.props.updateInputs('tipo_viaje', e.target.value) }>
                                                    <option value="1">Nacional</option>
                                                    <option value="2">Internacional</option>
                                                </select>
                                            </div>
                                        </div>

                                        <div className="col-md-2">
                                            <div className="form-group">
                                                <label className="control-label">Tipo de trayectoria</label>
                                                <select className="form-control input-sm" value={ creaciontiqueteaereo.get('tipo_trayecto') || '' } onChange={ e => this.props.updateInputs('tipo_trayecto', e.target.value) }>
                                                    <option value="1">Ida y vuelta</option>
                                                    <option value="2">Solo ida</option>
                                                    <option value="3">Multiples ciudades</option>
                                                </select>
                                            </div>
                                        </div>

                                        <div className="col-md-2">
                                            <div className="form-group">
                                                <label className="control-label">Cantidad de pasajeros</label>
                                                <input className="form-control input-sm" type="number" min="1" value={ creaciontiqueteaereo.get('cant_pasajeros') || '' } onChange={ e => this.props.updateInputs('cant_pasajeros', e.target.value)}/>
                                            </div>
                                        </div>

                                        <div className="col-md-2">
                                            <div style={{ marginTop:'22px' }}>
                                                <input type="checkbox" id="assist" value={ asistencia_vajero } onChange={ e => this.props.updateInputs(`asistencia_viajero`, e.target.checked)} disabled={ creaciontiqueteaereo.get('tipo_viaje') == 1 } />
                                                <label style={{ margin:'0 0 0 7px' }} className="control-label" htmlFor="assist" >Asistencia al viajero</label>
                                            </div>
                                        </div>


                                    </div>
                                </BoxSection>

                                <div className="separator"></div>

                                <BoxSection title="Trayectos" actions={ accionesTrayectos }>

                                    <table className="table table-condensed table-bordered table-striped table-sorted nowrap" id="table-trayectos">
                                        <thead>
                                            <tr>

                                                <th width="20px">
                                                    <input type="checkbox" style={{ verticalAlign: 'middle' }}  />
                                                </th>

                                                <th style={{ width: '23%' }}>Origen</th>

                                                {(creaciontiqueteaereo.get('tipo_trayecto') == 3) ? (
                                                    <Fragment>
                                                    <th style={{ width: '13%' }}>Fecha</th>
                                                    <th style={{ width: '10%' }}>Hora</th>
                                                    </Fragment>
                                                ) : (
                                                    <Fragment>
                                                    <th style={{ width: '13%' }}>Fecha ida</th>
                                                    <th style={{ width: '10%' }}>Hora ida</th>
                                                    </Fragment>
                                                )}

                                                <th style={{ width: '23%' }}>Destino</th>

                                                {(creaciontiqueteaereo.get('tipo_trayecto') == 1) && (
                                                    <Fragment>
                                                    <th style={{ width: '13%' }}>Fecha regreso</th>
                                                    <th style={{ width: '10%' }}>Hora regreso</th>
                                                    </Fragment>
                                                )}

                                            </tr>
                                        </thead>
                                        <tbody>
                                            {creaciontiqueteaereo.get('trayectos').map((t,i) => {

                                                // let origen = t.get('origen') && t.get('aeropuerto_origen') ? `${t.get('origen')}-${t.get('aeropuerto_origen')}` : ''
                                                // let destino = t.get('destino') && t.get('aeropuerto_destino') ? `${t.get('destino')}-${t.get('aeropuerto_destino')}` : ''

                                                return (
                                                    <tr key={ t.get('guid') } className={ t.get('selected') ? 'info' : '' }>
                                                        <td><input type="checkbox" style={{ verticalAlign: 'middle' }} value={ t.get('selected') } onChange={ e => this.props.updateInputs(`trayectos.${i}.selected`, e.target.value)} disabled={i==0} /></td>
                                                        <td>
                                                            <SelectorInput value={ t.get('origen') ? `${t.get('origen')} ${t.get('aeropuerto_origen')}` : '' } onClick={ () => this.handleOpenSelectorUbicacionOrigen(`trayectos.${i}`) } onReset={ () => this.onResetAeropuerto('origen', i) } />
                                                            {/* <input className="form-control input-sm" type="text" value={ t.get('origen') || '' } onChange={ e => this.handleAeropuerto(i, 'origen', e.target.value)} /> */}
                                                        </td>


                                                        <td><input className="form-control input-sm" type="date" value={ t.get('fecha_ida') || '' } onChange={ e => this.props.updateInputs(`trayectos.${i}.fecha_ida`, e.target.value)} /></td>
                                                        <td><input className="form-control input-sm" type="time" value={ t.get('hora_ida') || '' } onChange={ e => this.props.updateInputs(`trayectos.${i}.hora_ida`, e.target.value)} /></td>


                                                        <td>
                                                            <SelectorInput value={ t.get('destino') ? `${t.get('destino')} ${t.get('aeropuerto_destino')}` : '' } onClick={ () => this.handleOpenSelectorUbicacionDestino(`trayectos.${i}`) } onReset={ () => this.onResetAeropuerto('destino', i) } />
                                                            {/* <input className="form-control input-sm" type="text" value={ t.get('destino') || '' } onChange={ e => this.handleAeropuerto(i, 'destino', e.target.value)} /> */}
                                                        </td>
                                                        {(creaciontiqueteaereo.get('tipo_trayecto') == 1) && (
                                                            <Fragment>
                                                            <td>
                                                                <input className="form-control input-sm" type="date" value={ t.get('fecha_regreso') || '' } onChange={ e => this.props.updateInputs(`trayectos.${i}.fecha_regreso`, e.target.value)} />
                                                            </td>
                                                            <td>
                                                                <input className="form-control input-sm" type="time" value={ t.get('hora_regreso') || '' } onChange={ e => this.props.updateInputs(`trayectos.${i}.hora_regreso`, e.target.value)} />
                                                            </td>
                                                            </Fragment>
                                                        )}
                                                    </tr>
                                                )
                                            })}
                                        </tbody>
                                    </table>

                                </BoxSection>

                                <div className="separator"></div>

                                <BoxSection title="Distribución de centros de costos" actions={actionsDistribucionCencos}>
                                    <div className="box-content" >
                                        <table className="table table-condensed">
                                            <thead>
                                                <tr>
                                                    <th style={{ width: '20px' }} ></th>
                                                    <th>Ordenador del gasto</th>
                                                    <th>Centro de costo</th>
                                                    <th>Porcentaje</th>
                                                    <th></th>
                                                </tr>
                                            </thead>
                                            <tbody>

                                            {
                                                creaciontiqueteaereo.get('cencos').count() > 0 ? (creaciontiqueteaereo.get('cencos').map((x, n) => {
                                                    return (
                                                        <tr key={ `tr[${ x.get('id') ? x.get('id') : x.get('guid') }]` }  className={ x.get('selected') ? 'info-dark' : '' } >
                                                            <td ><input type="checkbox" style={{ marginTop: '6px' }} checked={ x.get('selected') || false } onChange={ (e) => this.props.updateInputs(`cencos.${n}.selected`, e.target.checked) } /></td>
                                                            <td>
                                                                <SelectorInput value={ x.getIn(['responsable', 'fullname']) || '' } onClick={ () => this.handleOpenSelector(`cencos.${n}.responsable`) } onReset={ () => this.props.updateInputs(`cencos.${n}.responsable`, null) } />
                                                            </td>
                                                            <td>
                                                                {
                                                                    x.get('responsable') ? (
                                                                        <SelectorInput value={ x.get('cenco') ? x.getIn(['cenco','codigo']) : '' } onClick={ () => this.handleOpenSelectorAddCenco(`cencos.${n}.cenco`, n) } onReset={ () => this.props.updateInputs(`cencos.${n}.cenco`, null) }/>
                                                                    ) : (
                                                                        <input className="form-control input-sm" placeholder="Seleccione un responsable del cenco" disabled />
                                                                    )
                                                                }
                                                            </td>
                                                            <td>
                                                                <input type="number" className="form-control input-sm" placeholder="Porcentaje" value={ x.get('porcentaje') ? x.get('porcentaje') : 0 }  onChange={ (e) => this.props.updateInputs(`cencos.${n}.porcentaje`, e.target.value) } disabled={ x.get('responsable') == null } />
                                                            </td>
                                                            <td style={{ width: '20px', verticalAlign: 'middle' }}>%</td>
                                                        </tr>
                                                    )
                                                })) : (
                                                        <tr>
                                                            <td colSpan={6} style={{ textAlign: 'center' }}>
                                                                Para agregar un centro de costo haga click en el botón <span style={{ color: '#888' }}><FontAwesome name="plus-circle" /></span>
                                                            </td>
                                                        </tr>
                                                )
                                            }
                                            </tbody>
                                        </table>
                                    </div>
                                </BoxSection>

                                <div className="separator"></div>

                                <BoxSection title="Observaciones">
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="form-group">
                                                <textarea type="text" className="form-control input-sm" rows={4} value={ creaciontiqueteaereo.get('observaciones') || '' } onChange={ (e) => this.props.updateInputs('observaciones', e.target.value) } />
                                            </div>
                                        </div>
                                    </div>
                                </BoxSection>

                                <div className="separator"></div>

                                <AttachedFilesBox
                                    files={ creaciontiqueteaereo.get('adjuntos') }
                                    removeFiles = { this.props.removeSolicitudTiqutesAereos }
                                    updateInputs = { this.props.updateInputs }
                                    obj={ creaciontiqueteaereo }
                                    check={ 'solicitud' }
                                />


                                <div className="separator"></div>


                                <BoxSection title="Pasajeros">

                                {creaciontiqueteaereo.get('pasajeros').map((p,i) => {


                                    const mode = p.get('pasaporte_adjunto') ? 'edit' : 'create'

                                    return (

                                        <Fragment key={ `Fragment[${i}]` }>

                                            <div className="separator"></div>

                                            <Box title={ `Pasajero #${i+1}` }>

                                                <Box title={ 'Información del pasajero' } onModal>

                                                    <div className="separator"></div>

                                                    <div className="row">

                                                        <div className="col-md-2">
                                                            <div className="form-group">
                                                                <label className="control-label">Tipo pasajero</label>
                                                                <select className="form-control input-sm" value={p.get('tipo_pasajero')} onChange={ e => this.props.updateInputs(`pasajeros.${i}.tipo_pasajero`, e.target.value)}>
                                                                    <option value="1">Empleado</option>
                                                                    <option value="2">Invitado</option>
                                                                </select>
                                                            </div>
                                                        </div>

                                                        {
                                                            (p.get('tipo_pasajero') == 1) ? (
                                                            <Fragment>
                                                                <div className="col-md-6">
                                                                    <div className="form-group">
                                                                        <label className="control-label">Nombre completo</label>
                                                                        <SelectorInput value={ p.get('fullname') ? p.get('fullname') : '' } onClick={ () => this.handleOpenSelectorAddPasajero(`pasajeros.${i}`) } onReset={ () => this.props.updateInputs(`pasajeros.${i}`, { selected: p.get('selected'), guid: p.get('guid') }) } />
                                                                    </div>
                                                                </div>
                                                            </Fragment>
                                                            ) : (
                                                            <Fragment>
                                                                <div className="col-md-3">
                                                                    <div className="form-group">
                                                                        <label className="control-label">Nombres</label>
                                                                        <input className="form-control input-sm" type="text" value={ p.get('nombres') || '' } onChange={ e => this.props.updateInputs(`pasajeros.${i}.nombres`, e.target.value)} />
                                                                    </div>
                                                                </div>
                                                                <div className="col-md-3">
                                                                    <div className="form-group">
                                                                        <label className="control-label">Apellidos</label>
                                                                        <input className="form-control input-sm" type="text" value={ p.get('apellidos') || '' } onChange={ e => this.props.updateInputs(`pasajeros.${i}.apellidos`, e.target.value)} />
                                                                    </div>
                                                                </div>
                                                            </Fragment>
                                                            )
                                                        }

                                                        <div className="col-md-2">
                                                            <div className="form-group">
                                                                <label className="control-label">Tipo de documento</label>
                                                                <select className="form-control input-sm" value={ p.get('tipo_documento') || 1 } onChange={ (e) => this.props.updateInputs(`pasajeros.${i}.tipo_documento`, e.target.value) }>
                                                                {
                                                                    Object.keys(tipos_identificacion).map((key, ikey) => {
                                                                        return (
                                                                            <option key={`opt[${i}][${ikey}]`} value={key}>{ tipos_identificacion[key] }</option>
                                                                        )
                                                                    })
                                                                }
                                                                </select>
                                                            </div>
                                                        </div>



                                                        <div className="col-md-2">
                                                            <div className="form-group">
                                                                <label className="control-label">No. de Documento</label>
                                                                <input className="form-control input-sm" type="text" value={ p.get('cedula') || '' } onChange={ e => this.props.updateInputs(`pasajeros.${i}.cedula`, e.target.value)} />
                                                            </div>
                                                        </div>



                                                    </div>


                                                    <div className="row">


                                                        <div className="col-md-3">
                                                            <div className="form-group">
                                                                <label className="control-label">Celular</label>
                                                                <input className="form-control input-sm" type="text" value={ p.get('celular') || '' } onChange={ e => this.props.updateInputs(`pasajeros.${i}.celular`, e.target.value)} />
                                                            </div>
                                                        </div>

                                                        <div className="col-md-3">
                                                            <div className="form-group">
                                                                <label className="control-label">Fecha nacimiento</label>
                                                                <input className="form-control input-sm" type="date" value={ p.get('fecha_nacimiento') || '' }  onChange={ e => this.props.updateInputs(`pasajeros.${i}.fecha_nacimiento`, e.target.value)} />
                                                            </div>
                                                        </div>


                                                        <div className="col-md-3">
                                                            <div className="form-group">
                                                                <label className="control-label">Correo</label>

                                                                {(p.get('tipo_pasajero') == 1) ? (
                                                                    <input className="form-control input-sm" type="text" value={ p.get('email') || '' } disabled />
                                                                ) : (
                                                                    <input className="form-control input-sm" type="text" value={ p.get('correo') || '' } onChange={ e => this.props.updateInputs(`pasajeros.${i}.correo`, e.target.value)} />
                                                                )}



                                                            </div>
                                                        </div>


                                                        <div className="col-md-3">
                                                            <div className="form-group">
                                                                <label className="control-label">Nacionalidad</label>
                                                                <input className="form-control input-sm" type="text" value={ p.get('nacionalidad') || '' } onChange={ e => this.props.updateInputs(`pasajeros.${i}.nacionalidad`, e.target.value)} disabled={tipo_viaje==1}  />
                                                            </div>
                                                        </div>

                                                    </div>

                                                    <div className="row">

                                                        <div className="col-md-3">
                                                            <div className="form-group">
                                                                <label className="control-label">No. Pasaporte</label>
                                                                <input className="form-control input-sm" type="text" value={ p.get('pasaporte') || '' } onChange={ e => this.props.updateInputs(`pasajeros.${i}.pasaporte`, e.target.value)} disabled={tipo_viaje==1} />
                                                            </div>
                                                        </div>


                                                        <div className="col-md-3">
                                                            <div className="form-group">
                                                                <label className="control-label">País expedición</label>
                                                                <input className="form-control input-sm" type="text" value={ p.get('pais_expedicion') || '' } onChange={ e => this.props.updateInputs(`pasajeros.${i}.pais_expedicion`, e.target.value)} disabled={tipo_viaje==1} />
                                                            </div>
                                                        </div>


                                                        <div className="col-md-3">
                                                            <div className="form-group">
                                                                <label className="control-label">Fecha caducidad pasaporte</label>
                                                                <input className="form-control input-sm" type="date" value={ p.get('fecha_caducidad_pasaporte') || '' } onChange={ e => this.props.updateInputs(`pasajeros.${i}.fecha_caducidad_pasaporte`, e.target.value)} onBlur={(e) => this.props.validateCaducidadPasaporte(e.target.value)} disabled={tipo_viaje==1} />
                                                            </div>
                                                        </div>


                                                        <div className="col-md-3">

                                                            <div className="form-group">

                                                                <label className="control-label">
                                                                    Adjuntar pasaporte pasajero {i + 1}
                                                                </label>

                                                                <label
                                                                    className={`form-control input-sm label-upload-file ${
                                                                        tipo_viaje == 2 ? 'label-upload-file-enabled' : 'label-upload-file-disabled'
                                                                    }`}
                                                                    onClick={
                                                                        tipo_viaje == 2
                                                                            ? () => {
                                                                                this.props.displayModalAddFile(true, 'Adjuntar pasaporte', mode, p.get('pasaporte_adjunto'), i);
                                                                                this.props.updateInputs('flagAdjunto', true);
                                                                            }
                                                                            : () => null
                                                                    }
                                                                    disabled={tipo_viaje == 1}
                                                                >
                                                                    <i className="fa fa-upload"></i>{' '}
                                                                    {p.get('pasaporte_adjunto') ? p.getIn(['pasaporte_adjunto', 'nombre']) : ' Seleccione un archivo...'}
                                                                </label>

                                                            </div>
                                                        </div>
                                                    </div>



                                                </Box>

                                                {
                                                    (asistencia_vajero) && (

                                                        <Fragment>

                                                            <div className="separator"></div>

                                                            <Box title={ 'Información asistencia de viaje' } onModal>

                                                                <div className="separator"></div>

                                                                <div className="row">

                                                                    <div className="col-md-4">
                                                                        <div className="form-group">
                                                                            <label className="control-label">País destino</label>
                                                                            <input className="form-control input-sm" type="text" value={ p.getIn(['asistencia', 'pais_destino']) || '' } onChange={ e => this.props.updateInputs(`pasajeros.${i}.asistencia.pais_destino`, e.target.value)} disabled={ asistencia_vajero == false }/>
                                                                        </div>
                                                                    </div>


                                                                    <div className="col-md-3">
                                                                        <div className="form-group">
                                                                            <label className="control-label">Fecha salida</label>
                                                                            <input className="form-control input-sm" type="date" value={ p.getIn(['asistencia', 'fecha_salida']) || '' } onChange={ e => this.props.updateInputs(`pasajeros.${i}.asistencia.fecha_salida`, e.target.value)} />
                                                                        </div>
                                                                    </div>

                                                                    <div className="col-md-3">
                                                                        <div className="form-group">
                                                                            <label className="control-label">Fecha regreso</label>
                                                                            <input className="form-control input-sm" type="date" value={  p.getIn(['asistencia', 'fecha_regreso']) || ''  } onChange={ e => this.props.updateInputs(`pasajeros.${i}.asistencia.fecha_regreso`, e.target.value)}  />
                                                                        </div>
                                                                    </div>

                                                                    <div className="col-md-2">
                                                                        <div className="form-group">
                                                                            <label className="control-label">Total días</label>
                                                                            <input className="form-control input-sm" type="text" value={ this.getTotalDias(i) || 0 }  disabled />
                                                                        </div>
                                                                    </div>


                                                                </div>

                                                            </Box>

                                                            <div className="separator"></div>

                                                            <Box title={ 'En caso de emergencia avisar a:' } onModal>

                                                                <div className="separator"></div>

                                                                <div className="row">

                                                                    <div className="col-md-3">
                                                                        <div className="form-group">
                                                                            <label className="control-label">Nombres y apellidos</label>
                                                                            <input className="form-control input-sm" type="text" value={ p.getIn(['asistencia', 'avisar_a']) || '' } onChange={ e => this.props.updateInputs(`pasajeros.${i}.asistencia.avisar_a`, e.target.value)} disabled = { asistencia_vajero == false }/>
                                                                        </div>
                                                                    </div>

                                                                    <div className="col-md-3">
                                                                        <div className="form-group">
                                                                            <label className="control-label">Dirección</label>
                                                                            <input className="form-control input-sm" type="text" value={ p.getIn(['asistencia', 'direccion']) || '' } onChange={ e => this.props.updateInputs(`pasajeros.${i}.asistencia.direccion`, e.target.value)} disabled={ asistencia_vajero == false } />
                                                                        </div>
                                                                    </div>

                                                                    <div className="col-md-2">
                                                                        <div className="form-group">
                                                                            <label className="control-label">Ciudad</label>
                                                                            <input className="form-control input-sm" type="text" value={ p.getIn(['asistencia', 'ciudad']) || '' } onChange={ e => this.props.updateInputs(`pasajeros.${i}.asistencia.ciudad`, e.target.value)} disabled={ asistencia_vajero == false } />
                                                                        </div>
                                                                    </div>


                                                                    <div className="col-md-2">
                                                                        <div className="form-group">
                                                                            <label className="control-label">Celular</label>
                                                                            <input className="form-control input-sm" type="text" value={ p.getIn(['asistencia', 'celular']) || '' } onChange={ e => this.props.updateInputs(`pasajeros.${i}.asistencia.celular`, e.target.value)} disabled={ asistencia_vajero == false } />
                                                                        </div>
                                                                    </div>


                                                                    <div className="col-md-2">
                                                                        <div className="form-group">
                                                                            <label className="control-label">Teléfono</label>
                                                                            <input className="form-control input-sm" type="text" value={ p.getIn(['asistencia', 'telefono']) || '' } onChange={ e => this.props.updateInputs(`pasajeros.${i}.asistencia.telefono`, e.target.value)}  disabled={ asistencia_vajero == false }/>
                                                                        </div>
                                                                    </div>


                                                                </div>

                                                            </Box>

                                                        </Fragment>

                                                    )
                                                }





                                            </Box>

                                        </Fragment>

                                    )
                                })}

                                </BoxSection>

                                <div className="separator"></div>



                                <ModalAddFile
                                    action={ () => flagAdjunto ? this.props.addFile() : this.props.addFileAdjunto() }
                                />

                            </Fragment>

                        </div>


                    </Box>

                </div>

                <ModalSelectorFromList />
                <ModalSelectorAirport />



            </div>
		)
	}
}

function mapStateToProps(state) {
    return {
        user: state.common.get('user'),
        creaciontiqueteaereo: state.creaciontiqueteaereo,
        enums: state.common.get('enums').toJS(),
        responsable: state.common.getIn(['parametros', 'SOLICITUDES']) ? state.common.getIn(['parametros', 'SOLICITUDES']).filter(x => x.get('TIPO_SOLICITUD') == state.creaciontiqueteaereo.get('tipo')).first() : null
    }
}

function mapDispatchToProps(dispatch) {
    return {
        updateInputs: (path, value) => dispatch(updateInputs(path, value)),
        addTrayecto: () => dispatch(addTrayecto()),
        removeTrayectos: () => dispatch(removeTrayectos()),
        createTiqueteAereo: () => dispatch(createTiqueteAereo()),
        displayModalAddFile: (show, title, mode, file, index) => dispatch(displayModalAddFile(show, title, mode, file, index)),
        updateInputsModalAddFile: (path, value) => dispatch(updateInputsModalAddFile(path, value)),
        selectFile: (file) => dispatch(selectFile(file)),
        addFile: () => dispatch(addFile()),
        addPasajero: (path) => dispatch(addPasajero(path)),
        showModalSelector: (title, fields, url, action, customFilter) => dispatch(showModalSelector(title, fields, url, action, customFilter)),
        selectFromSelector: (type, payload) => dispatch(selectFromSelector(type, payload)),
        showModalSelectorUrlAirports: (title, fields, url, action, customFilter) => dispatch(showModalSelectorUrlAirports(title, fields, url, action, customFilter)),
        addOrigen: (path,query) => dispatch(addOrigen(path,query)),
        addDestino: (path,query) => dispatch(addDestino(path,query)),
        addCencoSolicitud: () => dispatch(addCencoSolicitud()),
        removeCenco: () => dispatch(removeCenco()),
        validateCaducidadPasaporte: (fecha) => dispatch(validateCaducidadPasaporte(fecha)),
        enviarComentario: () => dispatch(enviarComentario()),
        eliminarComentario: (guid) => dispatch(eliminarComentario(guid)),
        editarComentario: (guid) => dispatch(editarComentario(guid)),
        addFileAdjunto: () => dispatch(addFileAdjunto()),
        removeSolicitudTiqutesAereos: () => dispatch(removeSolicitudTiqutesAereos())
    }
}




export default connect(mapStateToProps, mapDispatchToProps)(CreacionTiquetesAereo)



// WEBPACK FOOTER //
// ./src/containers/CreacionTiquetesAereo.jsx